export const community = {
  avatar: 'Profielfoto van {{name}}',
  breadcrumb: {
    overview: 'Netwerk',
  },
  detail: {
    disabled: 'Het profiel van deze freelancer staat niet meer openbaar.',
    error: {
      title: 'Fout bij het ophalen van het profiel.',
    },
  },
  enableCommunityProfileDialog: {
    actions: {
      goToSettings: 'Profiel aanmaken',
    },
    description:
      'Om te posten op het forum, te reageren op opdrachten, andere freelancers te zoeken, ... moet je een openbaar community-profiel hebben.<br/>Ga naar de instellingen om je profiel aan te maken.',
    title: 'Deelnemen aan de community',
  },
  header: {
    preview: 'Bekijk jouw profiel',
    title: 'Netwerk',
  },
  infoCards: {
    activity: {
      action: 'Filter op jouw activiteiten',
      description_one: '{{count}} freelancer deelt jouw activiteiten',
      description_other: '{{count}} freelancers delen jouw activiteiten',
      description_zero: 'Nog geen freelancers met dezelfde activiteiten',
      title: 'Dezelfde activiteiten',
    },
    error: 'Kon niet worden geladen',
    profile: {
      action: 'Profiel aanvullen',
      description: 'Vul je profiel zo goed mogelijk aan en vergroot je netwerk.',
      title: 'Deel je expertise en vind samenwerkingen',
    },
    region: {
      action: 'Filter op jouw regio',
      description_one: '{{count}} freelancer is actief in jouw regio',
      description_other: '{{count}} freelancers zijn actief in jouw regio',
      description_zero: 'Nog geen freelancers in jouw regio',
      title: 'Freelancers in jouw regio',
    },
  },
  overview: {
    errorLoading: 'Er liep iets mis bij het ophalen van het netwerk',
    filters: {
      activity: {
        label: 'Activiteiten',
      },
      name: {
        placeholder: 'Zoeken op naam',
      },
      openToWork: {
        text: 'Enkel beschikbaar voor opdrachten',
      },
      region: {
        label: 'Regio',
      },
    },
    loading: 'Laden...',
    locked: {
      button: 'Maak profiel openbaar',
      description: 'Maak je profiel openbaar om deel te worden van de Craft Community',
      success: 'Je profiel is nu openbaar. Welkom bij de Craft Community!',
    },
    resultCount_one: '{{count}} resultaat',
    resultCount_other: '{{count}} resultaten',
    resultCount_zero: 'Geen match gevonden op basis van je zoekcriteria',
  },
  profileCard: {
    activeInRegion: 'Actief in {{regions}}',
    openToWork: 'Beschikbaar',
    openDialog: 'Bekijk profiel van {{name}}',
    footer: {
      behance: 'Behance',
      facebook: 'Facebook',
      instagram: 'Instagram',
      linkedIn: 'LinkedIn',
      website: 'Website',
      mail: 'Email',
    },
  },
  regions: {
    Abroad: 'Buitenland',
    Antwerp: 'Antwerpen',
    Brussels: 'Brussel',
    EastFlanders: 'Oost-Vlaanderen',
    FlemishBrabant: 'Vlaams-Brabant',
    Hainaut: 'Henegouwen',
    Liege: 'Luik',
    Limburg: 'Limburg',
    Luxembourg: 'Luxemburg',
    Namur: 'Namen',
    WalloonBrabant: 'Waals-Brabant',
    WestFlanders: 'West-Vlaanderen',
  },
};
